import TimeAgo from 'javascript-time-ago';
import pt from 'javascript-time-ago/locale/pt-PT.json';

import 'View/Prototype/array';
import 'View/Prototype/number';
import 'View/Prototype/string';

TimeAgo.addDefaultLocale(pt);
